import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 1rem;
  max-width: 70vw;

  display: flex;
  width: 100%;

  @media (max-width: 900px) {
    margin-top: 0;
    max-width: 80vw;
  }

  @media (max-width: 720px) {
    max-width: 90vw;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
`;

export const TextClue = styled.p`
  font-size: 1.3rem;
  margin: 0 5px 0;

  @media (max-width: 900px) {
    font-size: 1rem;
  }

  @media (max-width: 540px) {
    font-size: 0.875rem;
  }
`;
